import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AuthStore } from "../+state/auth";

export const AdminRoleGuard: CanActivateFn = (_route, state) => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  if (authStore.isAdminRole()) {
    return true;
  }

  // Non-admins land on the read-only view of the same page.
  return router.parseUrl(state.url.replace(/\/edit(\?|$)/, "$1"));
};
